
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_kabis_99",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_kabis_1",
  "refresh": "awsui_refresh_qwoo0_kabis_120",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_kabis_1",
  "root": "awsui_root_qwoo0_kabis_149",
  "interior": "awsui_interior_qwoo0_kabis_185",
  "dropdown": "awsui_dropdown_qwoo0_kabis_99",
  "use-portal": "awsui_use-portal_qwoo0_kabis_196",
  "is-empty": "awsui_is-empty_qwoo0_kabis_248",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_kabis_255",
  "with-limited-width": "awsui_with-limited-width_qwoo0_kabis_259",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_kabis_262",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_kabis_268",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_kabis_274",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_kabis_277",
  "hide-block-border": "awsui_hide-block-border_qwoo0_kabis_284",
  "open": "awsui_open_qwoo0_kabis_293",
  "nowrap": "awsui_nowrap_qwoo0_kabis_302",
  "dropdown-content": "awsui_dropdown-content_qwoo0_kabis_99",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_kabis_313"
};
  